/**
 * Item Delete Button
 * Hover-visible delete button for schedule item cards.
 */

import { Trash2 } from "lucide-react";
import type { ScheduleItemRow } from "../../../../_logic/types/db-types";

interface ItemDeleteButtonProps {
  item: ScheduleItemRow;
  onDelete: (item: ScheduleItemRow) => void;
}

/** Hover-visible delete button for schedule item cards */
export function ItemDeleteButton({ item, onDelete }: ItemDeleteButtonProps) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onDelete(item);
      }}
      className="shrink-0 rounded p-1 text-gray-300 opacity-0 transition-opacity hover:text-red-500 group-hover/item:opacity-100 focus-visible:opacity-100"
      aria-label={`Delete ${item.title}`}
    >
      <Trash2 className="h-3.5 w-3.5" />
    </button>
  );
}
